const supportedLocales = [
  'en-au',
  'pt-br',
  'en-ca',
  'de-de',
  'es-es',
  'fr-fr',
  'fr-ca',
  'en-gb',
  'en-us',
  'it-it',
  'ja-jp',
  'ko-kr',
  'th-th',
  'zh-cn',
  'es-mx',
  'pl-pl',
  'ru-ru',
  'en-sg',
  'zh-tw'
];

const countryToLocale: Record<string, string> = {
  AU: 'en-au',
  BR: 'pt-br',
  CA: 'en-ca',
  DE: 'de-de',
  ES: 'es-es',
  FR: 'fr-fr',
  GB: 'en-gb',
  IT: 'it-it',
  JP: 'ja-jp',
  KR: 'ko-kr',
  MX: 'es-mx',
  PL: 'pl-pl',
  RU: 'ru-ru',
  SG: 'en-sg',
  TH: 'th-th',
  TW: 'zh-tw',
  US: 'en-us',
  CN: 'zh-cn'
};

const DEFAULT_LOCALE = 'en-ca';
const DUAL_LANGUAGE_REGION = 'quebec';
const COUNTRY_CODE_CANADA = 'ca';
const FRENCH_CANADA_LOCALE = 'fr-ca';

export const getBrowserLocaleFromIp = async (): Promise<string> => {
  try {
    const response = await fetch('https://get.geojs.io/v1/ip/geo.json');

    if (!response.ok) {
      return getBrowserLocale();
    }

    const data = await response.json();

    // handling for multi-language countries, only for Canada
    if (data.country_code?.toLowerCase() === COUNTRY_CODE_CANADA) {
      // Check browser language preference first
      const browserLang = navigator.language?.toLowerCase();

      // If browser is set to French, use fr-ca
      if (browserLang?.startsWith('fr')) {
        return FRENCH_CANADA_LOCALE;
      }

      const normalizedRegion = data.region?.toLowerCase();
      if (
        normalizedRegion === DUAL_LANGUAGE_REGION ||
        normalizedRegion === DUAL_LANGUAGE_REGION
      ) {
        return FRENCH_CANADA_LOCALE;
      }

      // Otherwise English Canada
      return DEFAULT_LOCALE;
    }

    // For other countries, use the mapping
    const locale = countryToLocale[data.country_code];

    if (locale && supportedLocales.includes(locale)) {
      return locale;
    }

    return DEFAULT_LOCALE;
  } catch (error) {
    console.error('IP geolocation failed:', error);
    return DEFAULT_LOCALE;
  }
};

export const getBrowserLocale = () => {
  const userLang =
    navigator.language || navigator.languages?.[0] || DEFAULT_LOCALE;
  const normalized = userLang.toLowerCase();

  if (supportedLocales.includes(normalized)) {
    return normalized;
  }

  const lang = normalized.split('-')[0];
  const match = supportedLocales.find((l) => l.startsWith(lang));

  return match || DEFAULT_LOCALE;
};
